export enum Languages {
  english = 'en',
  spanish = 'es',
  deutsch = 'de',
  portugues = 'pt',
}
